import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";

const Uploadlist = ({ medias }) => {
  const navigate = useNavigate();
  const videoRefs = useRef([]);

  function handleClick(media) {
    navigate("/Main", { state: { media, medias } });
  }

  function handleMouseOver(index) {
    const video = videoRefs.current[index];
    if (video && video.paused) {
      video.play().catch(error => console.error('Error playing video:', error));
    }
  }

  function handleMouseOut(index) {
    const video = videoRefs.current[index];
    if (video && !video.paused) {
      video.pause();
    }
  }

  return (
    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3" style={{ marginLeft: 4 }}>
      {medias &&
        medias.map((media, mediaIndex) => (
          <div key={media._id} className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3" style={{ marginLeft: 4 }}>
            <div>
              {media.videos.map((videos, videoIndex) => (
                <div key={videoIndex}>
                  <video
                    ref={el => videoRefs.current[mediaIndex * 100 + videoIndex] = el}
                    width="400"
                    height="240"
                    autoPlay={false}
                    loop
                    preload="auto"
                    muted
                    style={{ borderRadius: 8, backgroundColor: '#141618e8' }}
                    onMouseOver={() => handleMouseOver(mediaIndex * 100 + videoIndex)}
                    onMouseOut={() => handleMouseOut(mediaIndex * 100 + videoIndex)}
                    onClick={() => handleClick(media)}
                  >
                    <source src={videos} />
                  </video>
                  <p className="text-light">
                    {media.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        ))}
    </div>
  );
};

export default Uploadlist;

